import { createContext, useContext } from 'react';

import type { Dictionary, Locale } from './translations';

export interface LanguageState {
  locale: Locale;
  t: Dictionary;
  setLocale: (locale: Locale) => void;
  persistence?: {
    state: 'saving' | 'saved' | 'error';
    retry: () => void;
  };
}

export const LanguageContext = createContext<LanguageState | null>(null);

export const useLanguage = (): LanguageState => {
  const value = useContext(LanguageContext);
  if (value === null) throw new Error('LanguageProvider is required');
  return value;
};
